import TextArea from 'antd/es/input/TextArea'
import R from 'app/assets/R'
import { CODE_REGEX } from 'app/common/constants'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { useTranslation } from 'react-i18next'
export const HookFormCommon = () => {
  const { t } = useTranslation()

  return (
    <BaseSpace size={5}>
      <BaseSpace size={5}>
        <BaseForm.Item
          name={'name'}
          required
          label={'Tên công đoàn bộ phận'}
          rules={[
            {
              required: true,
              message: t(R.strings.require_field, {
                field: 'Tên công đoàn bộ phận',
              }),
            },
          ]}
        >
          <BaseInput placeholder={'Nhập tên công đoàn bộ phận'} />
        </BaseForm.Item>
        <BaseForm.Item
          name={'code'}
          required
          label={'Mã công đoàn bộ phận'}
          rules={[
            {
              required: true,
              message: t(R.strings.require_field, {
                field: 'Mã công đoàn bộ phận',
              }),
            },
            {
              pattern: CODE_REGEX,
              message: 'Mã công đoàn bộ phận sai định dạng',
            },
          ]}
        >
          <BaseInput placeholder="Nhập mã công đoàn bộ phận" />
        </BaseForm.Item>
        <BaseForm.Item name={'descriptions'} label={t(R.strings.description)}>
          <TextArea placeholder="Nhập mô tả" />
        </BaseForm.Item>
      </BaseSpace>
    </BaseSpace>
  )
}
